import { render, staticRenderFns } from "./MapBlockComponent.vue?vue&type=template&id=0beae252&"
import script from "./MapBlockComponent.vue?vue&type=script&lang=js&"
export * from "./MapBlockComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ArtImportedFrom: require('/web/components/art/ArtImportedFrom.vue').default})
